import {AppState} from '../store';

export const getAuthUser = (state: AppState) => state.auth.user;

export const getAuthLoading = (state: AppState) => state.auth.isLoading;

export const getAuthEmail = (state: AppState) => state.auth.user?.email || '';

export const getAuthToken = (state: AppState) => state.auth.user?.token || null;
